import { render, staticRenderFns } from "./HelpAndContact.vue?vue&type=template&id=4f9e310d&scoped=true&"
import script from "./HelpAndContact.vue?vue&type=script&lang=js&"
export * from "./HelpAndContact.vue?vue&type=script&lang=js&"
import style0 from "./HelpAndContact.vue?vue&type=style&index=0&id=4f9e310d&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e310d",
  null
  
)

export default component.exports